import React, { FC, ReactNode, useMemo, useState } from "react";

// i18n
import useI18n from "@I18n/hooks/useI18n";

// Stripe
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe, StripeElementsOptions } from "@stripe/stripe-js";
import { LoadingScreen } from "@UI/Components/LoadingScreen/LoadingScreen";

interface Props {
  children: ReactNode;
}

export const StripeProvider: FC<Props> = ({ children }) => {
  const { locale } = useI18n();
  const [isLoading, setIsLoading] = useState(true);

  const options = {
    locale: locale as StripeElementsOptions["locale"],
  };

  const getStripePromise = async () => {
    try {
      const result = await loadStripe(process.env.STRIPE_PUBLIC_KEY);
      setIsLoading(false);
      return result;
    } catch (e) {
      console.error(e);
    }
  };

  const stripePromise = useMemo(() => getStripePromise(), []);

  return (
    <Elements stripe={stripePromise} options={options}>
      {isLoading ? <LoadingScreen /> : children}
    </Elements>
  );
};
